import React, { FC, ReactElement, useContext } from 'react';
import { CSSObject, forBrands, styled } from '@core-ui/react-stitch';
import { LARGE, MEDIUM, SMALL, XLARGE } from '@core-ui/breakpoint-provider';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import GridContainer from '../GridContainer';
import GridElement from '../GridElement';
import { GridData, GridProps } from './types';

const DEFAULT_COLUMNS = {
  [XLARGE]: 3,
  [LARGE]: 3,
  [MEDIUM]: 2,
  [SMALL]: 2,
};

const DEFAULT_SIZES = {
  [XLARGE]: 1,
  [LARGE]: 1,
  [MEDIUM]: 1,
  [SMALL]: 1,
};

const GridSection = styled.section(({ theme }) => ({
  ...(forBrands(theme, {
    br: () => ({ boxSizing: 'border-box' }),
    brfs: () => ({ boxSizing: 'border-box' }),
    default: () => ({ boxSizing: 'border-box', padding: '0.5em' }),
  }) as CSSObject),
}));

const Grid: FC<GridProps> = (props: GridProps): ReactElement => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const isBrBrand = !!(abbrBrand === 'br' || abbrBrand === 'brfs');

  const { data, contents, index, columns, spacing, theme } = props;
  const productsOnFirstLoad = isBrBrand ? 9 : 8;
  const shouldBeLazyLoaded = (productIndex: number) =>
    index > 0 || productIndex >= productsOnFirstLoad;

  return (
    <GridSection>
      <GridContainer key={index} columns={{ ...DEFAULT_COLUMNS, ...columns }}>
        {data.map(({ type = '', sizes, ...data }: GridData, i: number) => {
          const ElementUi = contents[type] || contents.default;
          return (
            <GridElement
              // eslint-disable-next-line react/no-array-index-key
              key={`grid${index}:element${i}`}
              lazy={shouldBeLazyLoaded(i)}
              sizes={{ ...DEFAULT_SIZES, ...sizes }}
              spacing={spacing}
              theme={theme}
            >
              <ElementUi {...data} />
            </GridElement>
          );
        })}
      </GridContainer>
    </GridSection>
  );
};

export default Grid;
